@if (!disableCloseButton) {
  <button icon-button (click)="close()" class="close" data-ctx="button-close-modal">
    <gl-icon [name]="'closeIcon'"></gl-icon>
  </button>
}
@if (!user.isPremium) {
  <div>
    @if (logo && !logo.logoUrl) {
      <img
        class="logo-icon"
        src="/assets/svg/logo-blue-text.svg"
        alt="Goodloading"
        />
    }
  </div>
}
@if (user.isPremium) {
  <div>
    @if (logo && !logo.logoUrl) {
      <img
        class="newLogoPro"
        src="/assets/svg/logo-pro-blue-text.svg"
        alt="Goodloading"
        />
    }
  </div>
}
<div class="content">
  <ng-content></ng-content>
</div>
<section class="buttons">
  <ng-content select=".buttons"></ng-content>
</section>
